/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationEventPccPatientLeadsInner } from './IntegrationEventPccPatientLeadsInner';
import {
    IntegrationEventPccPatientLeadsInnerFromJSON,
    IntegrationEventPccPatientLeadsInnerFromJSONTyped,
    IntegrationEventPccPatientLeadsInnerToJSON,
} from './IntegrationEventPccPatientLeadsInner';

/**
 * 
 * @export
 * @interface IntegrationEventPccPatient
 */
export interface IntegrationEventPccPatient {
    /**
     * 
     * @type {Array<IntegrationEventPccPatientLeadsInner>}
     * @memberof IntegrationEventPccPatient
     */
    leads?: Array<IntegrationEventPccPatientLeadsInner>;
}

/**
 * Check if a given object implements the IntegrationEventPccPatient interface.
 */
export function instanceOfIntegrationEventPccPatient(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegrationEventPccPatientFromJSON(json: any): IntegrationEventPccPatient {
    return IntegrationEventPccPatientFromJSONTyped(json, false);
}

export function IntegrationEventPccPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventPccPatient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'leads': !exists(json, 'leads') ? undefined : ((json['leads'] as Array<any>).map(IntegrationEventPccPatientLeadsInnerFromJSON)),
    };
}

export function IntegrationEventPccPatientToJSON(value?: IntegrationEventPccPatient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'leads': value.leads === undefined ? undefined : ((value.leads as Array<any>).map(IntegrationEventPccPatientLeadsInnerToJSON)),
    };
}

